export default "__VITE_PUBLIC_ASSET__51ce7892__"